var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClothing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9128 13.6715L13.0707 5.67149C13.0305 5.28978 12.7086 5 12.3248 5H3.67519C3.29137 5 2.96949 5.28978 2.92931 5.67149L2.08721 13.6715C2.0406 14.1143 2.38781 14.5 2.83309 14.5H13.1669C13.6122 14.5 13.9594 14.1143 13.9128 13.6715Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7C5.75 7.13807 5.63807 7.25 5.5 7.25C5.36193 7.25 5.25 7.13807 5.25 7C5.25 6.86193 5.36193 6.75 5.5 6.75C5.63807 6.75 5.75 6.86193 5.75 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7C10.75 7.13807 10.6381 7.25 10.5 7.25C10.3619 7.25 10.25 7.13807 10.25 7C10.25 6.86193 10.3619 6.75 10.5 6.75C10.6381 6.75 10.75 6.86193 10.75 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7V4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4V7M13.0707 5.67149L13.9128 13.6715C13.9594 14.1143 13.6122 14.5 13.1669 14.5H2.83309C2.38781 14.5 2.0406 14.1143 2.08721 13.6715L2.92931 5.67149C2.96949 5.28978 3.29137 5 3.67519 5H12.3248C12.7086 5 13.0305 5.28978 13.0707 5.67149ZM5.75 7C5.75 7.13807 5.63807 7.25 5.5 7.25C5.36193 7.25 5.25 7.13807 5.25 7C5.25 6.86193 5.36193 6.75 5.5 6.75C5.63807 6.75 5.75 6.86193 5.75 7ZM10.75 7C10.75 7.13807 10.6381 7.25 10.5 7.25C10.3619 7.25 10.25 7.13807 10.25 7C10.25 6.86193 10.3619 6.75 10.5 6.75C10.6381 6.75 10.75 6.86193 10.75 7Z",
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/clothing.f721a0553aa2084ae5927e6950eab5c0.svg";
export { ForwardRef as ReactComponent };